import { Phone, Snowflake, WashingMachine, Utensils, Flame } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const services = [
  {
    id: 'refrigerator',
    title: 'Refrigerator Repair',
    description: 'Keep your food fresh with expert fridge diagnostics.',
    icon: Snowflake,
    image: 'https://images.unsplash.com/photo-1769739132671-ac41c439d51e?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
  },
  {
    id: 'washer-dryer',
    title: 'Washer & Dryer Repair',
    description: 'Same-day laundry room rescues.',
    icon: WashingMachine,
    image: 'https://images.unsplash.com/photo-1583172747862-afcb755ebd13?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
  },
  {
    id: 'dishwasher',
    title: 'Dishwasher Repair',
    description: 'Fixing leaks and drainage issues fast.',
    icon: Utensils,
    image: 'https://images.unsplash.com/photo-1758631130778-42d518bf13aa?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
  },
  {
    id: 'stove-oven',
    title: 'Stove & Oven Repair',
    description: 'Getting your kitchen back to cooking temperature.',
    icon: Flame,
    image: 'https://images.unsplash.com/photo-1699022835617-113db461af4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
  },
];

export const ServiceGrid = () => {
  return (
    <section className="py-20 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span 
            className="inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4"
            style={{ background: 'rgba(255, 107, 0, 0.1)', color: '#FF6B00' }}
          >
            Expert Repair Services
          </span>
          <h2 
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ fontFamily: 'Montserrat, sans-serif', color: '#1A2B4C' }}
          >
            What We Fix
          </h2>
          <p className="text-lg text-[#475569] max-w-2xl mx-auto">
            From freezing fridges to heating issues, our certified technicians handle it all.
          </p>
        </div>

        {/* Service Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card 
                key={service.id}
                className={`service-card glass-card overflow-hidden border-0 shadow-lg group cursor-pointer fade-up-delay-${index}`}
                data-testid={`service-${service.id}`}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="service-card-image w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1A2B4C]/80 to-transparent" />
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="flex items-center gap-2">
                      <div 
                        className="w-10 h-10 rounded-lg flex items-center justify-center"
                        style={{ background: '#FF6B00' }}
                      >
                        <IconComponent size={20} className="text-white" />
                      </div>
                      <h3 
                        className="text-lg font-bold text-white"
                        style={{ fontFamily: 'Montserrat, sans-serif' }}
                      >
                        {service.title}
                      </h3>
                    </div>
                  </div>
                </div>
                <CardContent className="p-5">
                  <p className="text-[#475569] mb-4">{service.description}</p>
                  <a
                    href="tel:647-919-6893"
                    className="inline-flex items-center gap-2 font-semibold transition-colors hover:gap-3"
                    style={{ color: '#FF6B00', fontFamily: 'Montserrat, sans-serif' }}
                    data-testid={`service-cta-${service.id}`}
                  >
                    <Phone size={16} />
                    <span>Book Same-Day Service</span>
                  </a>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServiceGrid;
